import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
  padding: 20px;
`;

export const Title = styled.h4`
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin-bottom: 5px;
`;

export const AmountContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
`;

export const QuantityText = styled.p`
  font-size: 20px;
  font-weight: bold;
  color: #8850bf;
`;

export const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.9375rem;

  .clearButton {
    min-width: 90.56px;
    background-color: #d02925;

    &:hover {
      background-color: #ad2c2a;
    }

    &:disabled {
      cursor: not-allowed;
      background-color: #d02925;
      opacity: 60%;
    }
  }

  .addButton {
    justify-content: center;

    min-width: 90.56px;
    background-color: #009e0e;

    &:hover {
      background-color: #007c0b;
    }

    &:disabled {
      cursor: not-allowed;
      background-color: #009e0e;
      opacity: 60%;
    }
  }
`;
